import React from 'react';

export const EllipsisVertical = () => (
    <>
        <circle cx='11' cy='4' r='3' />
        <circle cx='11' cy='12' r='3' />
        <circle cx='11' cy='20' r='3' />
    </>
);